export default __webpack_public_path__ + "static/media/image16.d4756f5f.jpg";